import classNames from 'classnames';
import React from 'react';

import { DISPLAY_TYPES } from 'components/common/UploadModal/utils';
import CoreDragger from 'ui/base/CoreDragger';
import CardUploader from 'ui/base/Upload';

import { cardUploadStyle } from '../ui.style';

const DEFAULT_CARD_SIZE = {
  width: '160px',
  height: '121px',
};

/**
 * @typedef {{
 *  disabled?: boolean,
 *  className?: string,
 *  displayMaxSizeMessage?: boolean,
 *  displayTypes: string[],
 *  size: 'small' | 'full',
 *  onClick : (tab: import("components/common/UploadModal/utils").DisplayTypeEnum, autoBrowse?: boolean) => void,
 *  allowed: import("hooks/useMediaRules").AllowedMedias,
 *  onBeforeUpload: (file:import('antd/lib/upload').RcFile, fileList: import('antd/lib/upload').RcFile[]) => void,
 * }} UploaderProps
 */

/** @type {React.FC<UploaderProps>} */
const Uploader = ({ onBeforeUpload, onClick, allowed, size, disabled, displayTypes, className, displayMaxSizeMessage }) => {
  const isCard = size === 'small';

  const handleDraggerOnClick = React.useCallback(
    (event, displayType, autoBrowse) => {
      event.preventDefault();
      event.stopPropagation();

      if (!disabled) {
        onClick?.(displayType, autoBrowse);
      }
    },
    [disabled, onClick]
  );

  const onWrapperClick = React.useCallback(
    event => {
      handleDraggerOnClick(event, DISPLAY_TYPES.COMPUTER, false);
    },
    [handleDraggerOnClick]
  );

  const commonProperties = React.useMemo(
    () => ({
      allowed,
      disabled,
      multiple: true,
      beforeUpload: onBeforeUpload,
      openFileDialogOnClick: false,
    }),
    [allowed, disabled, onBeforeUpload]
  );

  return (
    <div onClick={onWrapperClick} data-cy="media-uploader" className={classNames({ 'w-100': !isCard }, className)}>
      {!isCard && (
        <CoreDragger
          {...commonProperties}
          displayTypes={displayTypes}
          displayMaxSizeMessage={displayMaxSizeMessage}
          onClick={handleDraggerOnClick}
        />
      )}

      {isCard && (
        <CardUploader
          {...commonProperties}
          showCard
          {...DEFAULT_CARD_SIZE}
          displayMaxSizeMessage={displayMaxSizeMessage}
          className={cardUploadStyle}
        />
      )}
    </div>
  );
};

export default Uploader;
